// Global Instructions Rule Applied!
import React, { useEffect, useRef } from 'react'
import InputNumber from '../../InputNumber.jsx'

function AmountColumnRender({
  value,
  record,
  isEditing,
  currencySymbol,
  onFieldChange,
  onStartEditing,
  shouldFocus = false,
  hasError = false
}) {
  const inputRef = useRef(null)

  useEffect(() => {
    if (isEditing && shouldFocus && inputRef.current) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 100)
    }
  }, [isEditing, shouldFocus])

  if (isEditing) {
    return (
      <InputNumber
        ref={inputRef}
        value={value}
        onChange={(amountValue) => onFieldChange(record.key, 'amount', amountValue)}
        addonBefore={currencySymbol}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => value.replace(/,/g, '')}
        placeholder='Enter amount'
        size='small'
        style={{ width: '100%' }}
        min={0}
        status={hasError ? 'error' : undefined}
      />
    )
  }

  // Accounting-amount display: always two decimals (house 'currency' policy)
  const displayValue = value
    ? `${currencySymbol}${Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`
    : '-'

  return (
    <div
      className='inline-edit-label cursor-pointer hover:bg-gray-50 px-2 py-0.5 rounded text-sm leading-tight'
      style={{ minHeight: '16px' }}
      onClick={() => onStartEditing(record.key, 'amount')}
    >
      <span className={value ? '' : 'text-gray-400'}>{displayValue}</span>
    </div>
  )
}

function AmountColumn(props) {
  return <AmountColumnRender {...props} />
}

export const getAmountColumnConfig = (props) => ({
  title: 'Commitment',
  dataIndex: 'amount',
  key: 'amount',
  width: '40%',
  render: (value, record) => {
    const errorKey = `${record.key}-errors`
    const hasError = props.validationErrors?.[errorKey]?.amount

    return (
      <AmountColumn
        value={value}
        record={record}
        isEditing={props.editingRowKey === record.key}
        currencySymbol={props.currencySymbol}
        onFieldChange={props.handleFieldChange}
        onStartEditing={props.startEditing}
        shouldFocus={props.focusField === 'amount' && props.editingRowKey === record.key}
        hasError={hasError}
      />
    )
  }
})
